import { render, staticRenderFns } from "./self-assessment-report.vue?vue&type=template&id=68ff2e24"
import script from "./self-assessment-report.vue?vue&type=script&lang=js"
export * from "./self-assessment-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports